var map = {
	"./de-de.json": 1780,
	"./en-gb.json": 8838,
	"./en-us.json": 5275,
	"./es-es.json": 3494,
	"./fr-fr.json": 4050,
	"./it-it.json": 9452,
	"./ja-jp.json": 7155,
	"./ko-kr.json": 2533,
	"./pl-pl.json": 7718,
	"./pt-br.json": 8454,
	"./ru-ru.json": 5808,
	"./zh-cn.json": 9213,
	"./zh-tw.json": 9857
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 8072;